import type { FaireProductEntity } from "../../entity_types/product";

export const p_pf2r7fd6ha: FaireProductEntity = {
  token: "p_pf2r7fd6ha",
  type: "product",
  name: "10pc. Caramel Gift Bag - Set of 5",
  brandName: "Annie B's",
  imageUrl:
    "https://cdn.faire.com/fastly/865fd19d18b4667f989a3fe593cd17fa88ed5f8914bf785dd93b644b4c30ad70.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65a292801d5eccad339a1d322567cedbd84c9b70599a5a34aa5671b5bb8b01cf.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
